import { useEffect, useRef, useState } from "react";
import { CaretDown, MagnifyingGlass } from "@phosphor-icons/react";
import api from "../lib/api";

export default function WrmSelect({ value, onChange, testId }) {
  const [wrms, setWrms] = useState([]);
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    api.get("/admin/wrms", { params: { active_only: true } }).then((r) => setWrms(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const selected = wrms.find((w) => w.user_id === value);
  const filtered = wrms.filter((w) =>
    `${w.name} ${w.wrm_code || ""} ${w.region || ""}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-1.5" ref={ref}>
      <label className="label-caps">Assigned WRM</label>
      <div className="relative">
        <button type="button" data-testid={testId} onClick={() => setOpen(!open)}
          className="glass-input flex items-center justify-between gap-2 text-left">
          <span className={selected ? "text-white" : "text-zinc-500"}>
            {selected ? `${selected.name} — ${selected.wrm_code || ""} — ${selected.region || "—"}` : "Select WRM"}
          </span>
          <CaretDown size={14} className="shrink-0 text-zinc-500" />
        </button>
        {open && (
          <div className="absolute z-50 mt-1.5 w-full min-w-[280px] rounded-lg border border-white/10 bg-[#0A110D] shadow-2xl overflow-hidden"
            data-testid={`${testId}-dropdown`}>
            <div className="flex items-center gap-2 px-3 border-b border-white/[0.06]">
              <MagnifyingGlass size={14} className="text-zinc-500 shrink-0" />
              <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} data-testid={`${testId}-search`}
                placeholder="Search WRM..."
                className="w-full h-9 bg-transparent text-sm text-white placeholder:text-zinc-600 focus:outline-none" />
            </div>
            <div className="max-h-48 overflow-y-auto">
              <button type="button" onClick={() => { onChange(""); setOpen(false); setQ(""); }} data-testid={`${testId}-none`}
                className="w-full text-left px-3 py-2 text-xs text-zinc-500 hover:bg-white/[0.04] transition-colors duration-150">
                Unassigned
              </button>
              {filtered.map((w) => (
                <button type="button" key={w.user_id}
                  onClick={() => { onChange(w.user_id); setOpen(false); setQ(""); }}
                  data-testid={`${testId}-opt-${w.user_id}`}
                  className={`w-full text-left px-3 py-2.5 hover:bg-white/[0.04] transition-colors duration-150 ${value === w.user_id ? "bg-emerald-500/10" : ""}`}>
                  <p className="text-sm text-white font-medium">{w.name}</p>
                  <p className="tnum text-[10px] text-zinc-500">{w.wrm_code || "—"} · {w.region || "—"} · Active</p>
                </button>
              ))}
              {filtered.length === 0 && wrms.length > 0 && (
                <p className="px-3 py-3 text-xs text-zinc-500">No WRMs match your search.</p>
              )}
              {wrms.length === 0 && (
                <div className="px-3 py-4" data-testid={`${testId}-empty`}>
                  <p className="text-xs font-semibold text-zinc-300">No Active WRMs Found</p>
                  <p className="text-[11px] text-zinc-500 mt-1 leading-relaxed">
                    Create an active WRM before assigning a relationship manager to this client.
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
